import { render, staticRenderFns } from "./DepartmentAdmin.vue?vue&type=template&id=3732c54c&scoped=true&"
import script from "./DepartmentAdmin.vue?vue&type=script&lang=ts&"
export * from "./DepartmentAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentAdmin.vue?vue&type=style&index=0&id=3732c54c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3732c54c",
  null
  
)

export default component.exports